import Confirm from "@/components/confirm.vue";
import { ref } from "vue";

import { usePopup } from "@/utils/popup";
const { show: popupShow } = usePopup();

const showResolve = ref(null);
const popupOpts = {
    isClose: false,
    modalMaskStyle: { zIndex: 99999 }
}

const show = (message, confirmNm, cancelNm) => {
    return new Promise(resolve => {
        showResolve.value = resolve;
        popupShow(Confirm, popupOpts, { message, confirmNm, cancelNm }, null);
    });
}

const hide = (returnVal) => {
    showResolve.value(returnVal);
}

const useConfirm = () => {
    return show
}

export { useConfirm, hide };